import { ReactComponent as IcDrone } from '@assets/icons/24x24/target-icSign/icSign-drone-24.svg';
import { ReactComponent as IcIntrusion } from '@assets/icons/24x24/target-icSign/icSign-intrusion-24.svg';
import { Box, Icon } from '@chakra-ui/react';
import { getNotificationColor } from '@utils/data/notification.utils';

import { NotificationType, NotificationTypeEnum } from '@/types/data/data.types';

type Props = {
  notification: NotificationType;
  timelineStart: number;
  timelineEnd: number;
  containerWidth: number;
};

export default function TimelineNotification({
  notification,
  timelineStart,
  timelineEnd,
  containerWidth,
}: Readonly<Props>) {
  if (timelineStart === timelineEnd) {
    return <></>;
  }
  const notificationStart = new Date(notification.startTime).getTime();
  const icon = notification.type === NotificationTypeEnum.DRONE ? IcDrone : IcIntrusion;
  const iconColor = getNotificationColor(notification);
  const notificationPosition = ((notificationStart - timelineStart) / (timelineEnd - timelineStart)) * containerWidth;

  return (
    <Box
      position="absolute"
      height="24px"
      width="24px"
      top="38px"
      transform="translateX(-50%)"
      left={`${notificationPosition}px`}
      padding={0.5}
      zIndex="1"
      pointerEvents="none"
    >
      <Icon as={icon} height="24px" width="24px" color={iconColor} />
    </Box>
  );
}
